import React from 'react';

import { Badge } from '@/components/ui/badge';
import { FirmStatus } from '@/services/types/firms-types';

interface FirmStatusBadgeProps {
  status: FirmStatus;
  showLabel?: boolean;
  className?: string;
}

export const FirmStatusBadge: React.FC<FirmStatusBadgeProps> = ({
  status,
  showLabel = true,
  className = '',
}) => {
  const statusConfig = {
    [FirmStatus.ACTIVE]: {
      color: 'bg-green-100 text-green-800 hover:bg-green-100',
      label: FirmStatus.ACTIVE,
      indicator: '●',
    },
    [FirmStatus.TESTING]: {
      color: 'bg-blue-100 text-blue-800 hover:bg-blue-100',
      label: FirmStatus.TESTING,
      indicator: '●',
    },
    [FirmStatus.SOFTWARE_ONLY]: {
      color: 'bg-purple-100 text-purple-800 hover:bg-purple-100',
      label: FirmStatus.SOFTWARE_ONLY,
      indicator: '●',
    },
    [FirmStatus.NEW_LEAD]: {
      color: 'bg-yellow-100 text-yellow-800 hover:bg-yellow-100',
      label: FirmStatus.NEW_LEAD,
      indicator: '●',
    },
    [FirmStatus.OPEN]: {
      color: 'bg-indigo-100 text-indigo-800 hover:bg-indigo-100',
      label: FirmStatus.OPEN,
      indicator: '●',
    },
    [FirmStatus.CLOSED]: {
      color: 'bg-gray-100 text-gray-800 hover:bg-gray-100',
      label: FirmStatus.CLOSED,
      indicator: '○',
    },
  };

  // Default to ACTIVE if status is undefined or not in the config
  const config =
    status && statusConfig[status]
      ? statusConfig[status]
      : statusConfig[FirmStatus.ACTIVE];

  return (
    <Badge variant="outline" className={`${config.color} ${className}`}>
      <span className="mr-1" aria-hidden="true">
        {config.indicator}
      </span>
      {showLabel && config.label}
    </Badge>
  );
};
